export default __webpack_public_path__ + "static/media/publicity-team-member-3.34edc0b7.jpg";